import { render, staticRenderFns } from "./set-keyword-modal.vue?vue&type=template&id=13252080&scoped=true&"
import script from "./set-keyword-modal.vue?vue&type=script&lang=js&"
export * from "./set-keyword-modal.vue?vue&type=script&lang=js&"
import style0 from "./set-keyword-modal.vue?vue&type=style&index=0&id=13252080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13252080",
  null
  
)

export default component.exports